<template>
  <div class="solutions-page">
    <Head     :active="1"/>
    <div class="banner">
      <div class="background-container">
        <div v-for="(solution, index) in solutions" 
             :key="'bg-' + index"
             :class="['solution-bg', { active: activeSolutionIndex === index }]"
             :style="{ backgroundImage: `url(${solution.bgImage})` }">
        </div>
      </div>
      <div class="solutions-container">
        <div class="solutions-list">
          <div class="blue-indicator" :style="blueIndicatorStyle"></div>
          <div class="solutions-scroll-container" ref="scrollContainer">
            <div 
              v-for="(solution, index) in solutions" 
              :key="index"
              :class="['solution-item', { active: activeSolutionIndex === index }]"
              @click="toggleSolution(index)"
              @mouseenter="handleHover(index)"
            >
              <div class="solution-header">
                <h3 class="solution-title">{{ solution.title }}</h3>
              </div>
              <div class="solution-content" :style="getContentStyle(index)">
                <div class="content-wrapper">
                  <p>{{ solution.description }}</p>
                  <button class="customize-btn"  @click="btnclk" >定制方案</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="solution-detail" v-if="showDetail">
        <div class="solution-detail-content">
          <component 
            :is="getSolutionComponent"
            @close="showDetail = false"
          />
        </div>
      </div>
    </transition>
    <plan-dialog
          :isShow="isShow"
          v-if="isShow"
          @closeTop="closeTop"
        ></plan-dialog>
    <div>
        <Footer />
    </div>
  </div>
</template>

<script>
import Head from '@/components/head.vue'
import HvacSolution from '@/components/solutions/HvacSolution.vue'
import WaterSolution from '@/components/solutions/WaterSolution.vue'
import ChargingSolution from '@/components/solutions/ChargingSolution.vue'
import BatterySolution from '@/components/solutions/BatterySolution.vue'
import EnvironmentalSolution from '@/components/solutions/EnvironmentalSolution.vue'
import PensionSolution from '@/components/solutions/PensionSolution.vue'
import ApplianceSolution from '@/components/solutions/ApplianceSolution.vue'
import IndustrySolution from '@/components/solutions/IndustrySolution.vue'
import Footer from '@/components/footer2.vue'
import planDialog from '@/components/planDialog.vue'
export default {
  name: 'solutions',
  components: {
    Head,
    HvacSolution,
    WaterSolution,
    ChargingSolution,
    BatterySolution,
    EnvironmentalSolution,
    PensionSolution,
    ApplianceSolution,
    IndustrySolution,
    Footer,
    planDialog
  },
  data() {
    return {
      isShow:false,
      activeSolutionIndex: 0,
      hoverIndex: null,
      blueIndicatorPosition: 0,
      showDetail: true,
      currentSolution: {
        title: '暖通行业解决方案',
        description: '针对暖通空调行业提供了一站式暖通行业解决方案，帮助施建设备生产厂商远程监控空调设备运行状况，优化运行管理，实现节能减排。',
        bgImage: require('../../../public/img/internet/暖通行业解决方案.png'),
        type: 'hvac'
      },
      solutions: [
        {
          title: '暖通行业解决方案',
          description: '针对暖通空调行业提供了一站式暖通行业解决方案，帮助施建设备生产厂商远程监控空调设备运行状况，优化运行管理，实现节能减排。',
          bgImage: require('../../../public/img/internet/暖通行业解决方案.png'),
          type: 'hvac'
        },
        {
          title: '净水器智能解决方案',
          description: '为行业客户提供远程水质监测、数据存储与处理、水质超标预警，设备远程控制的一站式解决方案。',
          bgImage: require('../../../public/img/internet/净水器banner2.png'),
          type: 'water'
        },
        {
          title: '充电桩智能解决方案',
          description: '为充电桩行业提供远程监控和管理解决方案，解决传统充电桩管理空间离散化、设备孤岛化和数据碎片化问题，提升运维效率，强化安全性能，优化运营成本。',
          bgImage: require('../../../public/img/internet/充电桩banner最新.png'),
          type: 'charging'
        },
        {
          title: '换电柜智联网解决方案',
          description: '云百帮助换电柜厂商打造无人值守型全天候设备管理平台，实现被动运维向主动运维模式的转变，提高运维效率，降低运维成本，减少设备安全隐患，确保换电柜安全稳定运行。',
          bgImage: require('../../../public/img/internet/换电柜banner1.png'),
          type: 'battery'
        },
        {
          title: '环保设备网联出海方案',
          description: '云百通过物联网和大数据等技术，支持提前预警，减少设备异常停机带来的产能损失,降低设备故障发生的频率,保证设备最大运行效率，提高环保处理系统效率。',
          bgImage: require('../../../public/img/internet/环保设备出口最新.png'),
          type: 'environmental'
        },
        {
          title: '智能养老解决方案',
          description: '通过医疗设备运营平台的构建，实现线上数据分析+线下运维服务的高效闭环运维模式，实现安心养老，智慧养老',
          bgImage: require('../../../public/img/internet/养老解决方案banner最新1.png'),
          type: 'pension'
        },
        {
          title: '小家电智能解决方案',
          description: '云百提供一站式家电家居智能化解决方案，依托云百自有平台，通过"硬件+流量+云平台+应用"软硬件整合服务，帮助传统家电企业快速实现智能化升级。',
          bgImage: require('../../../public/img/internet/小家电banner21.png'),
          type: 'appliance'
        },
        {
          title: '智能工业解决方案',
          description: '为行业客户提供4G+工业互联网全生命周期解决方案，助力企业数字化生产转型，降本增效，节能环保。',
          bgImage: require('../../../public/img/internet/智能工业banner21.png'),
          type: 'industry'
        }
      ],
      itemCollapsedHeight: 38, // 未展开项高度（30px高度+8px上下padding）
      itemExpandedHeight: 190 // 展开项最大高度（与样式保持一致）
    }
  },
  computed: {
    blueIndicatorStyle() {
      return {
        transform: `translateY(${this.blueIndicatorPosition}px)`
      }
    },
    getSolutionComponent() {
      if (!this.currentSolution) return null;
      const typeMap = {
        hvac: 'HvacSolution',
        water: 'WaterSolution',
        charging: 'ChargingSolution',
        battery: 'BatterySolution',
        environmental: 'EnvironmentalSolution',
        pension: 'PensionSolution',
        appliance: 'ApplianceSolution',
        industry: 'IndustrySolution'
      };
      return typeMap[this.currentSolution.type] || hvac;
    }
  },
  created() {
    // 确保初始化时打开第一个解决方案
    this.toggleSolution(0);
  },
  mounted() {
    // 禁止鼠标滚轮滚动
    if (this.$refs.scrollContainer) {
      this.$refs.scrollContainer.addEventListener('wheel', this.preventScroll, { passive: false });
    }
    this.$nextTick(() => {
      this.setFixedScrollContainerHeight();
      this.scrollToSolution(this.activeSolutionIndex);
    });
  },
  beforeDestroy() {
    if (this.$refs.scrollContainer) {
      this.$refs.scrollContainer.removeEventListener('wheel', this.preventScroll);
    }
  },
  methods: {
    btnclk() {
      this.isShow = true;
    },
    closeTop() {
      this.isShow = false;
    },
    toggleSolution(index) {
      this.activeSolutionIndex = index;
      this.currentSolution = this.solutions[index];
      this.showDetail = true;
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.setFixedScrollContainerHeight();
          this.scrollToSolution(index);
        });
      });
    },
    setFixedScrollContainerHeight() {
      this.$nextTick(() => {
        const scrollContainer = this.$refs.scrollContainer;
        if (!scrollContainer) return;
        const items = scrollContainer.querySelectorAll('.solution-item');
        if (!items.length) return;
        let collapsedHeights = [];
        let expandedHeight = 0;
        items.forEach((item, i) => {
          if (i === this.activeSolutionIndex) expandedHeight = item.offsetHeight;
          else if (collapsedHeights.length < 4) collapsedHeights.push(item.offsetHeight);
        });
        // 容器高度 = 1个展开项 + 4个未展开项
        const containerHeight = expandedHeight + collapsedHeights.reduce((a, b) => a + b, 0);
        scrollContainer.style.height = containerHeight + 'px';
      });
    },
    scrollToSolution(index) {
      const scrollContainer = this.$refs.scrollContainer;
      const items = scrollContainer.querySelectorAll('.solution-item');
      if (!items.length) return;
      let collapsedHeights = [];
      let expandedHeight = 0;
      items.forEach((item, i) => {
        if (i === index) expandedHeight = item.offsetHeight;
        else if (collapsedHeights.length < 4) collapsedHeights.push(item.offsetHeight);
      });
      const containerHeight = expandedHeight + collapsedHeights.reduce((a, b) => a + b, 0);
      const currentItem = items[index];
      if (!currentItem) return;
      const itemOffsetTop = currentItem.offsetTop;
      const itemHeight = currentItem.offsetHeight;
      let idealScrollTop = itemOffsetTop - (containerHeight / 2) + (itemHeight / 2);
      // 边界处理
      if (index < 1) idealScrollTop = 0;
      // 终极修正：最后两个直接滚到底部
      if (index > items.length - 1) {
        idealScrollTop = scrollContainer.scrollHeight - containerHeight;
      }
      if (idealScrollTop < 0) idealScrollTop = 0;
      if (scrollContainer.scrollTo) {
        scrollContainer.scrollTo({
          top: idealScrollTop,
          behavior: 'smooth'
        });
      } else {
        scrollContainer.scrollTop = idealScrollTop;
      }
      this.$nextTick(() => {
        const containerRect = scrollContainer.getBoundingClientRect();
        const itemRect = currentItem.getBoundingClientRect();
        this.blueIndicatorPosition = itemRect.top - containerRect.top;
      });
    },
    preventScroll(e) {
      e.preventDefault();
    },
    handleHover(index) {
      this.hoverIndex = index;
    },
    getContentStyle(index) {
      return {
        display: this.activeSolutionIndex === index ? 'block' : 'none',
        opacity: this.activeSolutionIndex === index ? '1' : '0'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.solutions-page {
  width: 100%;
  min-height: 100vh;
  background: #fff;
}

.banner {
  position: relative;
  width: 100%;
  height: 650px;
  overflow: hidden;
}

.background-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.solution-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 1920px;
  height: 650px;
  transition: all 0.8s ease;
  background-size: cover;
  background-position: center;
  opacity: 0;
  transform: scale(1.05);
  
  &.active {
    opacity: 1;
    transform: scale(1);
  }
}

.solutions-container {
  position: absolute;
  z-index: 100;
  top: 0;
  left: calc(5% + 100px);
  width: 100%;
  height: 100%;
  display: flex;
  padding: 0;
}

.solutions-list {
  position: relative;
  width: 400px;
  margin-top: 5%;
  padding: 0 100px;
  text-align: left;
  overflow: hidden;
  margin-left:65px;
  
  // 白色背景线
  // &::before {
  //   content: '';
  //   position: absolute;
  //   top: 18px;
  //   left: 0px;
  //   width: 3px;
  //   height: 290px;
  //   background: #fff;
  //   border-radius: 1.5px;
  //   z-index: 1;
  // }

  // 蓝色活动指示线
  // .blue-indicator {
  //   position: absolute;
  //   top: -10px;
  //   left: 0;
  //   width: 3px;
  //   height: 120px;
  //   background: #1890ff;
  //   border-radius: 1.5px;
  //   z-index: 2;
  //   transition: transform 0.3s ease;
  //   pointer-events: none;
  // }
}

.solutions-scroll-container {
  position: relative;
  overflow-y: auto; // 允许垂直滚动
  transition: none; // 不再用 transform
  margin-left: -100px;
  width: 600px;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
  /* 高度由JS动态设置，保证显示1个展开+4个未展开 */
  min-height: 390px;
}
.solutions-scroll-container::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Webkit */
}

.solution-item {
  position: relative;
  padding-left: 16px;
  height: 30px;
  transition: all 0.3s ease;
  padding-top: 4px;
  padding-bottom: 4px;
  // margin-bottom: 20px;
  
  .solution-header {
    display: flex;
    align-items: center;
    position: relative;
    height: 45px;
    z-index: 3;
    // padding-top: 20px;
    

  }
  
  .solution-title {
    font-size: 24px;
    color: #999;
    margin: 0;
    padding: 0;
    line-height: 24px;
    cursor: pointer;
    font-weight:500;
    transition: all 0.3s ease;
    font-family: PingFang SC, PingFang SC-600;
  }
  
  .solution-content {
    display: none;
    opacity: 0;
    transition: opacity 0.3s ease;
    
    .content-wrapper {
      padding: 0 0 10px;
      font-weight: 200;
      font-size: 20px;
      // padding-bottom: 20px;
      p {
        color: #333;
        line-height: 1.3;
        margin: 0 0 12px;
        font-size: 20px;
        margin-top: 10px;
      }
    }
  }
  
  &:hover {
    .solution-title {
      color: #1e77ec;
      font-size: 24px;
    }
  }
  
  &.active {
    height: auto;
    // margin-top: 10px;
    padding-top: 20px;
    // padding-bottom: 15px;
    // margin-bottom: 10px;

    .solution-title {
      color: #1890ff;
      font-size: 40px;
      font-weight: 600;
      margin-top: 10px;
    }
    
    .solution-content {
      display: block;
      opacity: 1;
    }
  }
}

.customize-btn {
  background: #1e77ec;;
  color: #fff;
  border: none;
  padding: 8px 24px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  margin-top: 20px;
  // margin-bottom: 20px;
  &:hover {
    background: #000CF9;
  }
}

.solution-detail {
  width: 100%;
  min-height: 200px;
  background: #fff;
  padding: 40px 0;
}

.solution-detail-content {
  width: 80%;
  margin: 0 auto;
}

.detail-placeholder {
  font-size: 18px;
  color: #333;
  text-align: center;
  margin-top: 200px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style> 